// Copyright (c) 2025 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import Logo from './Logo';
import Navigation from './Navigation';
import UserMenu from './UserMenu';
import './layout.css';

export default function TopBanner() {
  return (
    <>
      {/* Skip to content link for accessibility */}
      <a href="#main-content" className="skip-to-content">
        Skip to main content
      </a>
      <header
        className="top-banner"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          height: '64px',
          backgroundColor: 'white',
          borderBottom: '1px solid rgba(34, 36, 38, 0.15)',
          zIndex: 1000,
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
        }}
        role="banner"
      >
        <div
          className="top-banner-container"
          style={{
            height: '100%',
            padding: '0 1.5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            maxWidth: '100%',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '2rem',
              flex: 1,
            }}
          >
            <Logo />
            <Navigation />
          </div>
          <UserMenu />
        </div>
      </header>
    </>
  );
}
